<template>
  <div class="v-card-body">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCardBody"
};
</script>
